import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class InquiryOverview extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      processing: false,
      validationMessage: "",
      emailMarketing: true,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
  }

  toggleEmailMarketing(event) {
    event.target.checked
      ? this.setState({ emailMarketing: true })
      : this.setState({ emailMarketing: false })
  }

  finish() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.submit()
    }
  }

  submit() {
    this.setState({ processing: true })
    Amplitude.trackEvent("inquiry_flow:submit_inquiry_pressed", {
      experience_name: "inquiry_flow",
      marina_id: this.props.marina.mcom_id,
      marina_name: this.props.marina.name,
      visible_form: this.props.visibleForm,
      transaction_type: this.props.transactionType,
    })
    const formData = {
      special_request: this.props.specialRequest,
    }
    if (this.props.boat.id) {
      formData.boat_id = this.props.boat.id
    } else {
      formData.boat_name = this.props.boat.name
      formData.boat_type = this.props.boat.boatType
      formData.length_overall = this.props.boat.lengthOverall
      formData.beam = this.props.boat.beam
    }
    formData.height = this.props.boat.height
    formData.draw = this.props.boat.draw
    formData.name = this.props.contact.name
    formData.email = this.props.contact.email
    formData.phone = this.props.contact.phone
    formData.custom_fields = this.props.customFields
    formData.transaction_type = this.props.transactionType
    formData.start_date = this.props.startDate
    formData.end_date = this.props.endDate
    formData.hubspot_sync = this.state.emailMarketing

    if (this.props.registration) {
      formData["registration_attributes[number]"] =
        this.props.registration.number
      formData["registration_attributes[expiration_date]"] =
        this.props.registration.expirationDate
    }
    if (this.props.insurance) {
      formData["insurance_attributes[company_name]"] =
        this.props.insurance.companyName
      formData["insurance_attributes[policy_number]"] =
        this.props.insurance.policyNumber
      formData["insurance_attributes[expiration_date]"] =
        this.props.insurance.expirationDate
    }
    if (this.props.embedForm || this.props.androidRequest) {
      formData.embed_form = true
    }
    $.post(this.props.postUrl, formData, (data) => {
      window.location.href = data.redirect_to
    }).fail((data) => {
      this.setState({
        validationMessage: JSON.parse(data.responseText).error,
        processing: false,
      })
    })
  }

  renderTransactionTypeSection() {
    return (
      <FormGroup
        autoFocus
        name="transactionType"
        label="Category"
        inputType="select"
        value={this.props.transactionType}
        onChange={(event) =>
          this.props.handleTransactionType(event.target.value)
        }
        validation={this.validator.message(
          "category",
          this.props.transactionType,
          "required"
        )}
      >
        <option value="" disabled="true">
          Select Request Category
        </option>
        {_.map(this.props.transactionTypes, (value, key) => (
          <option key={key} value={key}>
            {value}
          </option>
        ))}
      </FormGroup>
    )
  }

  renderDateSection() {
    return (
      <div className="row nested-row">
        <div className="col-xs-6">
          <FormGroup
            name="inquiry.startDate"
            label="Start Date"
            value={this.props.startDate}
            startDate={moment()}
            endDate={
              this.props.endDate &&
              moment(this.props.endDate).format("YYYY-MM-DD")
            }
            inputType="datepicker"
            onChange={(startDate) =>
              this.props.handleStartDate(
                moment(new Date(startDate)).format("YYYY-MM-DD")
              )
            }
          />
        </div>
        <div className="col-xs-6">
          <FormGroup
            name="inquiry.endDate"
            label="End Date"
            value={this.props.endDate}
            startDate={
              (this.props.startDate &&
                moment(this.props.startDate).format("YYYY-MM-DD")) ||
              moment()
            }
            inputType="datepicker"
            onChange={(endDate) =>
              this.props.handleEndDate(
                moment(new Date(endDate)).format("YYYY-MM-DD")
              )
            }
          />
        </div>
      </div>
    )
  }

  renderRequestSection() {
    return (
      <div>
        <FormGroup
          name="specialRequest"
          label="Request"
          inputType="textarea"
          rows="4"
          value={this.props.specialRequest}
          onChange={(event) =>
            this.props.handleSpecialRequest(event.target.value)
          }
          placeholder={`Please include any details about your Inquiry such as special requests, location, or anything that may help ${this.props.marina.name} serve you better.`}
          validation={this.validator.message(
            "request",
            this.props.specialRequest,
            "required"
          )}
        />
      </div>
    )
  }

  renderMarketingSection() {
    if (!this.props.contact.id && !this.props.whiteLabel) {
      return (
        <div>
          <FormGroup
            name="email_marketing"
            label="Join Dockwa's community for the latest news and updates."
            labelClassName="text-gray-500 font-normal pl-1"
            inputType="checkbox"
            value={this.state.emailMarketing}
            onChange={this.toggleEmailMarketing.bind(this)}
            className="mb-4 ml-0.5 mt-0 flex cursor-pointer pl-4"
          />
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        {this.renderTransactionTypeSection()}
        {this.renderDateSection()}
        {this.renderRequestSection()}
        {this.renderMarketingSection()}
        {this.validator.messageWhenPresent(this.state.validationMessage, {
          className: "mb-2.5 text-danger text-bold",
        })}
        <NextButton
          click={this.finish.bind(this)}
          processing={this.state.processing}
          processingText=" Submitting Inquiry..."
          icon=""
          text="Submit Inquiry"
          btnClass="btn btn-primary w-full"
        />
      </div>
    )
  }
}

InquiryOverview.propTypes = {
  marina: PropTypes.shape({
    mcom_id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  boat: PropTypes.object,
  contact: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  insurance: PropTypes.object,
  registration: PropTypes.object,
  customFields: PropTypes.object,
  specialRequest: PropTypes.string,
  handleSpecialRequest: PropTypes.func.isRequired,
  postUrl: PropTypes.string,
  embedForm: PropTypes.bool,
  androidRequest: PropTypes.bool,
  visibleForm: PropTypes.string,
  transactionType: PropTypes.string,
  handleTransactionType: PropTypes.func.isRequired,
  transactionTypes: PropTypes.object,
  startDate: PropTypes.string,
  handleStartDate: PropTypes.func.isRequired,
  endDate: PropTypes.string,
  handleEndDate: PropTypes.func.isRequired,
  whiteLabel: PropTypes.bool,
}

export default InquiryOverview
